import React from 'react';
import { BaseInputProps, Dropdown } from 'ui-builder';
import { useTimezonesHelper } from './timezones';

interface TimezoneDropdownProps extends BaseInputProps<string> {
  hideLabel?: boolean;
}

export function TimezoneDropdown(props: TimezoneDropdownProps) {
  const deviceTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const timezonesHelper = useTimezonesHelper(deviceTimezone);

  const options = timezonesHelper.getTimezones();

  return (
    <Dropdown<string>
      options={options}
      placeholder={`Device timezone: ${deviceTimezone}`}
      {...props}
    />
  );
}
